import { Model } from 'pinia-orm';
import { Attr, BelongsTo, Bool, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Project from './Project';
import ReportSectionConfig from './ReportSectionConfig';
/* --- user header --- */
/* --- end user header --- */

export default class Report extends Model {
  static entity = 'App\\Models\\Report';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare title: string;
  @Str('')
  declare export_file_name: string;
  @Num(undefined)
  declare auto_generate_day: number | undefined;
  @Attr(undefined)
  declare issue_to: {
    email: string;
    user?: number;
    user_details?: {
      id: number;
      name: string;
      email: string;
    };
  }[] | undefined;
  @Str('')
  declare email_message: string;
  @Bool(false)
  declare document_control_version: boolean;
  @Bool(false)
  declare is_active: boolean;
  @Bool(false)
  declare save_export: boolean;
  @Bool(false)
  declare show_header: boolean;
  @Bool(false)
  declare show_footer: boolean;
  @Num(0)
  declare project_id: number;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  // relations
  @BelongsTo(() => Project, 'project_id', 'id')
  declare project: Project;
  @HasMany(() => ReportSectionConfig, 'report_id', 'id')
  declare report_section_configs: ReportSectionConfig[];
  /* --- end user code --- */
}
